import { render, staticRenderFns } from "./spider-window-mymessage.vue?vue&type=template&id=2cc697bf&scoped=true&"
import script from "./spider-window-mymessage.vue?vue&type=script&lang=js&"
export * from "./spider-window-mymessage.vue?vue&type=script&lang=js&"
import style0 from "./spider-window-mymessage.vue?vue&type=style&index=0&id=2cc697bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc697bf",
  null
  
)

export default component.exports